import { IInputStep } from 'interfaces/IInputStep';

/**
 * Reports whether a task's `steps` array names the same `stepId` more than
 * once.
 *
 * Step ids are meant to be unique within a task, and re-ordering depends on it
 * completely: every part of the feature addresses a row by its id, and
 * `swapStepsById` resolves one with `findIndex`, which answers with the first
 * match. Where two steps share an id, grabbing the second one silently moves
 * the first, both rows highlight together, and — because the id is also the
 * React key for the row — the list itself renders unpredictably once anything
 * about it changes.
 *
 * Duplicates do occur: OP-2321 surfaced them in seeded data whose steps carry
 * a placeholder GUID. Rather than re-order the wrong row, callers disable
 * re-ordering for the task and say why.
 */
export const hasDuplicateStepIds = (steps: IInputStep[]): boolean => {
  const seen = new Set<string>();

  for (const step of steps) {
    if (seen.has(step.stepId)) return true;
    seen.add(step.stepId);
  }

  return false;
};

export default hasDuplicateStepIds;
